import { AuthConfig } from '@domgen/dgx-fe-authentication';
import { AppConfig } from '../../models/config/app-config.type';

export const authConfigFactory = (config: AppConfig): AuthConfig => ({
  authApi: config.authApi,
  recaptchaSession: false,
  userApi: config.userApi,
});
